import { FadeUp, Eyebrow } from "./Reveal";
import { IMAGES } from "../constants";

const STATS = [
  { value: "15+", label: "Anni di esperienza" },
  { value: "3.000+", label: "Interventi completati" },
  { value: "24h", label: "Tempo medio di risposta" },
  { value: "57", label: "Marche trattate" },
];

export const Trust = () => (
  <section data-testid="trust-section" className="py-24 md:py-32 bg-[#0A0D12] border-y border-white/10">
    <div className="mx-auto max-w-7xl px-6 md:px-12">
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 items-stretch">
        <FadeUp className="lg:col-span-5">
          <div className="relative h-full min-h-[320px] rounded-3xl overflow-hidden border border-white/10">
            <img
              src={IMAGES.technician}
              alt="Tecnico F&C Impianti"
              className="absolute inset-0 w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-[#07090D]/80 to-transparent" />
            <p className="absolute bottom-6 left-6 font-mono-tech text-xs uppercase tracking-[0.25em] text-[#00D2FF]">
              Il tuo tecnico di fiducia
            </p>
          </div>
        </FadeUp>

        <div className="lg:col-span-7 flex flex-col justify-between gap-12">
          <FadeUp delay={0.1}>
            <Eyebrow color="text-[#00D2FF]">Perché sceglierci</Eyebrow>
            <h2 className="font-display font-semibold tracking-tighter text-4xl sm:text-5xl mt-4">
              La caldaia si guasta il sabato sera.
              <span className="text-[#94A3B8]"> Noi rispondiamo anche il sabato sera.</span>
            </h2>
            <p className="mt-6 max-w-xl text-base md:text-lg text-[#94A3B8]">
              Niente call center: parli direttamente con il tecnico che verrà a
              casa tua. Preventivo chiaro prima di iniziare, nessuna sorpresa in
              fattura.
            </p>
          </FadeUp>

          <div className="grid grid-cols-2 md:grid-cols-4 gap-px bg-white/10 rounded-3xl overflow-hidden border border-white/10">
            {STATS.map((s, i) => (
              <FadeUp key={s.label} delay={0.15 + i * 0.08} className="bg-[#0A0D12]">
                <div data-testid={`stat-${i}`} className="p-6 md:p-8">
                  <p className="font-display font-semibold text-3xl md:text-4xl tracking-tight text-[#FF6B00]">
                    {s.value}
                  </p>
                  <p className="mt-2 text-xs md:text-sm text-[#94A3B8]">{s.label}</p>
                </div>
              </FadeUp>
            ))}
          </div>
        </div>
      </div>
    </div>
  </section>
);
